
import { Component } from 'vue-property-decorator';
import AmountDisplayerFilterable from '@/components/reports-v3/components/filterables/AmountDisplayerFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import { getTableName } from '@/worker/db/sqlHelpers';
import SelectFilter from '@/components/reports-v3/components/filters/SelectFilter.vue';

@Component({
	components: {
		AmountDisplayerFilterable,
		SelectFilter,
	},
})
export default class BpCashOnHandNumberDisplayer extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['transactions'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['dateAsOf'];

	public amount: number = 0;
	public selectedCashType: string | null = null;
	public cashTypeList: string[] = [];

	public get expensiveHook() {
		const { selectedAsOfDate, selectedCashType } = this;
		return JSON.stringify([selectedAsOfDate, selectedCashType]);
	}

	public async expensiveCalc() {
		const escapeStr = (s: string) => s.replace(/'/g, '\'\'');
		const table = getTableName('transactions');
		const baseFilter = `TRY_CAST("DOCDATE" AS BIGINT) <= ${this.selectedAsOfDate}
				AND "ACCTYPE" = 'CA' AND "SPECIALACCTYPE" = 'CH'`;

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['transactions']);
		this.checkInterrupted(jobId);

		this.generateLoadingText(0.3);

		const namesResult = await queryHead.rawQuery(`
			SELECT DISTINCT "SPECIALACCTYPENAME"
			FROM ${table}
			WHERE ${baseFilter}
			ORDER BY "SPECIALACCTYPENAME"
		`);
		this.checkInterrupted(jobId);

		this.cashTypeList = namesResult.map((r: any) => r.SPECIALACCTYPENAME);

		let nameFilter = '';
		if (this.selectedCashType) {
			nameFilter = ` AND "SPECIALACCTYPENAME" = '${escapeStr(this.selectedCashType)}'`;
		}

		const result = await queryHead.rawQuery(`
			SELECT SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as total
			FROM ${table}
			WHERE ${baseFilter}${nameFilter}
		`);
		this.checkInterrupted(jobId);

		this.amount = Number(result[0] && result[0].total) || 0;

		this.saveHistory('amount', 'cashTypeList');
	}

	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
